import { render } from "./DynBase.vue?vue&type=template&id=3c8b4cb5&scoped=true&bindings={\"shared\":\"options\",\"obj\":\"props\",\"action\":\"props\",\"titi\":\"setup\",\"tutu\":\"setup\",\"jechange\":\"setup\",\"modele\":\"setup\"}"
import script from "./DynBase.vue?vue&type=script&lang=js"
export * from "./DynBase.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3c8b4cb5"

export default script